export default __webpack_public_path__ + "static/strategic-pillars-510b6f4ea33df634dad384300d100f39.png";